import axios from "axios";
import { GENERAL_URL_API } from "../../../urls";

/**
 * Edits an existing super institute.
 *
 * @async
 * @param {Object} instituto - The object containing super institute information.
 * @param {string} instituto.id - The id of the super institute to edit.
 * @param {string} instituto.nombre - The new name for the super institute.
 * @param {number} instituto.lecturasDiarias - The new number of daily readings.
 * @returns {Promise<Object>} A promise that resolves to the response data from the API.
 */
export const editarSuperInstituto = async ({ id, nombre, lecturasDiarias }) => {
  const fd = new FormData();
  fd.append("id", id);
  fd.append("nombre", nombre);
  fd.append("lecturasDiarias", lecturasDiarias);

  const { data } = await axios.post(
    `${GENERAL_URL_API}/superInstituto/editarSuperInstitutos`,
    fd,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
}; 